import { styled } from "@mui/material/styles";
import { Box, Paper } from "@mui/material";
import colours from "../../theme/Colours";

export const NotificationDropdown = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "100%",
  right: 0,
  width: "400px",
  maxHeight: "370px",
  overflowY: "auto",
  marginTop: "8px",
  background: colours.background2,
  borderRadius: "6px",
  padding: "10px",
  boxShadow: theme.shadows[8],
  border: "1px solid rgba(0,0,0,0.08)",
  zIndex: 999,
  minHeight: "60px",
}));

export const NotificationCard = styled(Paper)(() => ({
  padding: "10px",
  display: "flex",
  gap: "8px",
  position: "relative",
  boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
}));

export const EmptyStateContainer = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "40px",
  color: "#666",
};

export const EmptyStateText = {
  textAlign: "center",
  fontSize: "12px",
  fontStyle: "italic",
};

export const NotificationsList = {
  gap: "6px",
  display: "flex",
  flexDirection: "column",
};

export const NotificationCardStyles = {
  backgroundColor: colours.background2,
  border: `1px solid ${colours.noDataFoundCard}`,
  boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
};

export const NotificationIconContainer = {
  width: "20px",
  height: "20px",
};

export const NotificationContent = {
  padding: "0px 25px 0px 0px",
  alignItems: "flex-start",
  textAlign: "left",
};

export const NotificationHeader = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

export const ChipStyles = {
  color: colours.buttonBGColor,
  borderRadius: "4px",
  background: "#E9EAED",
  height: "20px",
  "& .MuiChip-label": {
    fontFamily: "Poppins, sans-serif",
    fontWeight: 500,
    fontStyle: "italic",
    fontSize: "10px",
    padding: "0 6px",
  },
};

export const DateText = {
  fontFamily: "Poppins, sans-serif",
  fontSize: "10px",
};

export const ProductNameText = {
  mt: "4px",
  fontSize: "12px",
  fontFamily: "Poppins, sans-serif",
};

export const MessageText = {
  fontFamily: "Poppins, sans-serif",
};

export const CloseButtonStyles = {
  position: "absolute",
  top: 0,
  right: 4,
};

export const HeaderContainer = {
  px: 1,
  pb: 1,
};

export const HeaderText = {
  fontWeight: 600,
  fontFamily: "Poppins, sans-serif",
};
